import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tir-pm-search-input" }
const _hoisted_2 = { class: "tir-pm-search-input__input-container" }
const _hoisted_3 = { class: "tir-pm-search-input__right-click-area" }
const _hoisted_4 = ["onClick"]

import { TirPmIconView } from "tir-pm-icon-view";
import { PropType, computed, useSlots, ref, watch } from "vue";
import {
  CrossCompactIcon,
  MagnifyingGlassIcon,
  ChevronRightIcon,
} from "tir-style-system/icons/outline";

import { NegativeCross, ChevronDownCompact } from "tir-style-system/icons/solid";
import { TirPmInput } from "tir-pm-input";
import {
  TirPmOptionList,
  TirPmOptionListGroupSeparator,
  TirPmOptionListItemElement,
} from "tir-pm-option-list";
import { TirPmSpinner } from "tir-pm-spinner";


export default /*#__PURE__*/_defineComponent({
  __name: 'TirPmSearchInput',
  props: {
  /**
   * Закрываемый
   */
  isSmall: { type: Boolean as PropType<boolean>, default: false },
  /**
   * Значение
   */
  modelValue: {
    type: [String, Number] as PropType<string | number>,
    default: null,
  },
  /**
   * Надпись когда ничего не найдено
   */
  isWithoutOptionLabel: { type: String as PropType<string>, default: "Ничего не нашлось" },
  /**
   * Использовать ли option-list
   */
  isWithPopup: { type: Boolean as PropType<boolean>, default: true },
  /**
   * Плейсхолдер для инпута
   */
  placeholder: { type: String as PropType<string>, default: "Плейсхолдер" },
  /**
   * Максимальная высота optionlist
   */
  maxHeight: { type: Number as PropType<number>, default: 240 },
  /**
   * Лейбл
   */
  label: { type: String as PropType<string>, default: "Лейбл" },
  /**
   * Идет ли загрузка
   */
  isLoading: { type: Boolean as PropType<boolean>, default: false },
  /**
   * Отключенный
   */
  isDisabled: { type: Boolean as PropType<boolean>, default: false },
},
  emits: ["update:modelValue", "input", "onClearSearchInput", "enter"],
  setup(__props, { expose: __expose, emit }) {

const props = __props;



/**
 * Пропсы
 */


/**
 * Слоты
 */
const slots = useSlots();

/**
 * Значение поиска
 */
const searchString = ref<string | number>("");

/**
 * Фокус у инпута
 */
const isFocused = ref(false);

/**
 * Значение
 */
const value = computed({
  get: () => {
    return props.modelValue == null ? searchString.value : props.modelValue;
  },
  set: (value) => {
    emit("update:modelValue", value);
    searchString.value = value;
  },
});

/**
 * Переключение фокуса
 */
const onChangeFocus = (focusValue: boolean) => {
  isFocused.value = focusValue;
};

/**
 * Очистить инпут поиска
 */
const onClearInput = () => {
  emit("onClearSearchInput");
  value.value = "";
};
/**
 * Событие ввода
 */
const onInput = (value: string | number) => {
  emit("input", value);
};

__expose({
  value: searchString,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(TirPmInput), {
        label: props.label,
        class: "tir-pm-search-input__input",
        placeholder: props.placeholder,
        modelValue: value.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((value).value = $event)),
        onFocus: onChangeFocus,
        onBlur: onChangeFocus,
        onInput: onInput,
        onEnter: _cache[2] || (_cache[2] = ($event: any) => (emit('enter'))),
        isAutocomplete: false,
        isSmallSize: !props.isSmall,
        isDisabled: props.isDisabled,
        isMicro: props.isSmall,
        isShowHint: false,
        isWithHint: false
      }, {
        leftInputAddons: _withCtx(() => [
          _createVNode(_unref(MagnifyingGlassIcon), { class: "tir-pm-search-input__glass-icon" })
        ]),
        hintMessage: _withCtx(() => [
          _renderSlot(_ctx.$slots, "hintMessage")
        ]),
        rightInputAddons: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            (!searchString.value && !value.value && __props.isWithPopup)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["tir-pm-search-input__chevron-button", {
                'tir-pm-search-input__chevron-button--focused': isFocused.value,
              }]),
                  onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                }, [
                  _createVNode(_unref(ChevronDownCompact), { class: "tir-pm-search-input__chevron-icon" })
                ], 2))
              : _createCommentVNode("", true),
            (value.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "tir-pm-search-input__close-button",
                  onClick: _withModifiers(onClearInput, ["stop"])
                }, [
                  _createVNode(_unref(NegativeCross), { class: "tir-pm-search-input__close-icon" })
                ], 8, _hoisted_4))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 3
      }, 8, ["label", "placeholder", "modelValue", "isSmallSize", "isDisabled", "isMicro"])
    ]),
    (__props.isWithPopup)
      ? (_openBlock(), _createBlock(_unref(TirPmOptionList), {
          key: 0,
          isOpened: isFocused.value,
          maxHeight: props.maxHeight,
          isUseClickOutside: false,
          isWithoutOptionLabel: props.isWithoutOptionLabel
        }, {
          content: _withCtx(() => [
            (!props.isLoading)
              ? _renderSlot(_ctx.$slots, "content", { key: 0 })
              : _createCommentVNode("", true),
            (props.isLoading)
              ? (_openBlock(), _createBlock(_unref(TirPmOptionListItemElement), {
                  key: 1,
                  class: "tir-pm-search-input__loading"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(TirPmSpinner))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 3
        }, 8, ["isOpened", "maxHeight", "isWithoutOptionLabel"]))
      : _createCommentVNode("", true)
  ]))
}
}

})